import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MessagingService } from '../../../core/services/messaging.service';
import { ArcAngelService } from '../../../core/services/arc-angel.service';
import { PhoneboxService } from '../../../core/services/Phonebox.service ';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule } from '@angular/forms';
// interface Phone {
//   number: string;
//   type: string;
// }

export interface Phone {
  id: string;
  userId: string;
  carrier: string;
  type: string;
  purpose: string | null;
  label: string | null;
  number: string;
  extension: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}


interface User {
  companyName: string;
  hasMobilePhone: boolean;
  name: string;
  orgId: number;
  orgIds: number[];
  phones: Phone[];
  userId: number;
}
@Component({
  selector: 'app-phonebox',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './phonebox.component.html',
  styleUrls: ['./phonebox.component.css']
})
export class PhoneboxComponent implements OnInit, OnDestroy {
  @Input() user!: User;
  @Input() phone!: string;
  @Input() toUserId!: string;
  @Input() toUserFullName!: string;
  @Input() toCompanyName!: string;
  mydata: any = {};
  selectedPhone?: Phone;

  constructor(
    private messagingService: MessagingService,
    private arcAngelService: ArcAngelService,
    private phoneboxService: PhoneboxService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.phoneboxService.setUp();
    if (this.user && this.user.phones?.length) {
      this.selectedPhone = this.user.phones[0];
    }
  }

  onPhoneChange(selected: Phone): void {
    this.phone = selected.number; // update the `phone` input property
  }

  ngOnDestroy(): void {
    this.phoneboxService.cleanUp();
  }

  isConnecting(): boolean {
    const status = this.phoneboxService.getConnectionStatus();
    return status === 'ringing' || status === 'connecting';
  }

  isConnected(): boolean {
    return this.phoneboxService.getConnectionStatus() === 'open';
  }

  isDisconnected(): boolean {
    const status = this.phoneboxService.getConnectionStatus();
    return status === 'closed' || status === '';
  }

  deviceReady(): boolean {
    return this.phoneboxService.getDeviceStatus() === 'ready';
  }

  isMuted(): boolean {
    return this.phoneboxService.isMuted();
  }

  connect(): void {
    // const params = {
    //   fromEntity: 'ORGANIZATION',
    //   fromId: this.data.myOrgId,
    //   fromTargetId: this.phoneboxService.data.organizationPhoneId,
    //   toEntity: 'USER',
    //   toId: this.toUserId,
    //   toTargetId: this.data.selectedPhone.id
    // };

    if (!this.selectedPhone) {
      return;
    } 
    this.phoneboxService.connect(this.selectedPhone.number);
  }

  disconnect(): void {
    this.phoneboxService.disconnect();
  }

  toggleMute(bool: boolean): void {
    this.phoneboxService.toggleMute(bool);
  }

  close(): void {
    // In Angular you usually *hide* the component instead of removing DOM manually
    // This should be handled by parent using *ngIf
  }
}
